import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import { Breadcrumbs } from "@/components/site/Breadcrumbs";
import { motion } from "framer-motion";
import { Link } from "@tanstack/react-router";

const SITEMAP_DATA = [
  {
    title: "Principais",
    links: [
      { label: "Início", href: "/" },
      { label: "Quem Somos", href: "/quem-somos" },
      { label: "Blog", href: "/blog" },
      { label: "Contato", href: "/contato" },
    ]
  },
  {
    title: "Painel IPTV",
    links: [
      { label: "Painel IPTV (Geral)", href: "/painel-iptv" },
      { label: "Painel IPTV Pós Pago", href: "/painel-iptv/pos-pago" },
      { label: "Melhor Painel IPTV", href: "/painel-iptv/melhor" },
      { label: "Franquia IPTV", href: "/painel-iptv/franquia" },
      { label: "Painel IPTV White Label", href: "/painel-iptv/white-label" },
      { label: "Painel IPTV Automático", href: "/painel-iptv/automatico" },
      { label: "Painel IPTV para Revendedores", href: "/painel-iptv/revendedores" },
      { label: "Como Funciona um Painel IPTV", href: "/painel-iptv/como-funciona" },
    ]
  },
  {
    title: "Curso IPTV",
    links: [
      { label: "Curso IPTV Profissional", href: "/curso-iptv" },
    ]
  },
  {
    title: "Revenda IPTV",
    links: [
      { label: "Revenda IPTV (Geral)", href: "/revenda-iptv" },
      { label: "Como Ser Revendedor IPTV", href: "/revenda-iptv/como-ser" },
      { label: "Revenda IPTV Pós Pago", href: "/revenda-iptv/pos-pago" },
      { label: "Plano Revendedor IPTV", href: "/revenda-iptv/plano" },
      { label: "Quanto Ganha um Revendedor IPTV", href: "/revenda-iptv/quanto-ganha" },
      { label: "Revenda IPTV para Iniciantes", href: "/revenda-iptv/iniciantes" },
    ]
  },
  {
    title: "Aplicativos IPTV",
    links: [
      { label: "Aplicativos IPTV (Geral)", href: "/aplicativos-iptv" },
      { label: "One X", href: "/aplicativos-iptv/one-x" },
      { label: "FunPlay", href: "/aplicativos-iptv/funplay" },
      { label: "Lazer Play", href: "/aplicativos-iptv/lazer-play" },
      { label: "RP725", href: "/aplicativos-iptv/rp725" },
      { label: "Blessed", href: "/aplicativos-iptv/blessed" },
      { label: "IBO Player", href: "/aplicativos-iptv/ibo-player" },
      { label: "VuPlayer", href: "/aplicativos-iptv/vuplayer" },
      { label: "PlaySim", href: "/aplicativos-iptv/playsim" },
      { label: "Assist Plus", href: "/aplicativos-iptv/assist-plus" },
      { label: "Blessed Player", href: "/aplicativos-iptv/blessed-player" },
    ]

  },
  {
    title: "Tutoriais IPTV",
    links: [
      { label: "Tutoriais IPTV (Geral)", href: "/tutoriais-iptv" },
      { label: "IPTV na TV Samsung", href: "/tutoriais-iptv/samsung" },
      { label: "IPTV na TV LG", href: "/tutoriais-iptv/lg" },
      { label: "IPTV na TV Box", href: "/tutoriais-iptv/tv-box" },
      { label: "IPTV no Fire Stick", href: "/tutoriais-iptv/fire-stick" },
      { label: "IPTV no Android", href: "/tutoriais-iptv/android" },
      { label: "IPTV no iPhone", href: "/tutoriais-iptv/iphone" },
      { label: "Configuração de Aplicativos IPTV", href: "/tutoriais-iptv/configuracao" },
    ]
  },
  {
    title: "Institucional & Legal",
    links: [
      { label: "Segurança", href: "/transparencia-e-seguranca" },
      { label: "Privacidade", href: "/politica-de-privacidade" },
      { label: "Termos de Uso", href: "/termos-de-uso" },
      { label: "Cookies", href: "/politica-de-cookies" },
      { label: "LGPD", href: "/lgpd" },
      { label: "Sitemap", href: "/sitemap" },
    ]
  }
];

export const Route = createFileRoute("/sitemap")({
  head: () => ({
    meta: [
      { title: "Sitemap - P2 PRO | Mapa Completo do Portal" },
      { name: "description", content: "Navegue por todas as seções e artigos do portal P2 PRO. Encontre tutoriais, guias de revenda e downloads de aplicativos em um só lugar." },
    ],
  }),
  component: () => (
    <Layout>
      <main className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6">
          <Breadcrumbs items={[{ label: "Mapa do Site", href: "/sitemap" }]} />
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-16"
          >
            <h1 className="text-4xl md:text-6xl font-black tracking-tighter leading-tight mb-8">
              MAPA DO SITE
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-4xl">
              Localize rapidamente qualquer conteúdo em nosso portal. Nossa estrutura foi organizada para facilitar seu acesso a tutoriais, downloads e informações sobre revenda.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
            {SITEMAP_DATA.map((section, idx) => (
              <motion.div
                key={section.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
              >
                <h2 className="text-xl font-black uppercase tracking-widest text-electric mb-6 flex items-center gap-3">
                  <div className="w-8 h-px bg-electric/30" />
                  {section.title}
                </h2>
                <ul className="flex flex-col gap-4">
                  {section.links.map(link => (
                    <li key={link.href}>
                      <Link 
                        to={link.href as any}
                        className="text-muted-foreground hover:text-white transition-colors flex items-center gap-2 group"
                      >
                        <div className="w-1.5 h-1.5 rounded-full bg-electric/20 group-hover:bg-electric transition-colors" />
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </main>
    </Layout>
  ),
});
